// modal.js

import { modal } from '../actions';

const initialState = {
  showModal: false
};

const modal_reducers = (state, action) => {
  if (typeof state === 'undefined') return initialState;
  switch (action.type) {
    case modal.types.MODAL_HIDE:
      return { ...state, ...initialState };
    case modal.types.MODAL_SHOW:
      return { ...state, showModal: true };
    default:
      return state;
  }
};

export default modal_reducers;



// WEBPACK FOOTER //
// ./src/store/reducers/modal.js